var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery page"},[_c('ul',{staticClass:"image-gallery"},_vm._l((165),function(n,index){return _c('li',{key:index,staticClass:"image"},[_c('img',{staticClass:"img",attrs:{"src":_vm.getImgUrl(n),"loading":"lazy"}})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }